// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import Vue from 'vue'
import axios from './http'
import VueRouter from "vue-router";
import store from "./store/index.js";
import App from './App'
import MyPlugin from  './plugins/MyPlugin.js'
import ZoomChart from  './plugins/ZoomChart.js'
import canvasPlugin from  './plugins/CanvasPlugin.js';
import modalPlugin from  './plugins/Modal.js';
import pagePlugin from  './plugins/jquery.page.js';
import api from "./common/api.js";
import $ from 'jquery';
import _ from 'underscore';
// import '../static/js/jquery.mousewheel.js'
// import '../static/js/jquery.mCustomScrollbar.js'
// import '../static/js/perfect-scrollbar.css'



Vue.config.productionTip = false
Vue.config.debug = true;
// 暴露
window.$ = $;
window._ = _;
window.axios = axios;
window.api = api;
// 插件
Vue.use(VueRouter);
//ajax插件
Vue.use(MyPlugin);
//图表插件
Vue.use(ZoomChart);
// canvas插件
Vue.use(canvasPlugin);
// 模态框插件
Vue.use(modalPlugin);
//分页插件
Vue.use(pagePlugin);

import router from "./routes.config.js";
import directives from "./directives/pushlink.js";
//注册全局路由跳转指令
Vue.directive("mylink",directives.mylink);
// 注册全局title指令
Vue.directive("title",directives.title);
Vue.directive("focus",directives.focus);
Vue.directive("refresh",directives.refresh);

// 全局注册组件
Vue.component("item-list",Vue.extend(require("./components/ItemList.vue")));

// //match函数,路由拦截
router.beforeEach(function(to,from,next){

// 	var token = window.localStorage.getItem('token')


// 	if( token && (to.name == "login")&& (from.name != null)){
// 		console.log(11)
// 		next({path:'/ModuleCate'})
// 		return;
// 	}
// 	// 是否需要路由拦截
// 	if( to.meta.requireLogin ){
// 		// 是否登录
// 		if( token ){
// 			// 不是必须加，只是本项目利用了mylink指令 通过路由增加样式
			store.state.url = to.path;
			next()
// 		}else{
// 			alert("请登录")
// 			next({path:'/login'})
// 		}
// 	}else{
// 		store.state.url = to.path;
//     	next();
// 	}
});

//创建和挂载根实例，创建的时候Vue构造函数中要添加router属性
var app = new Vue({
    router,
    render:h => h(App),
    store
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js